// extracted by mini-css-extract-plugin
export default {"profileSelect":"CompanyUserList_profileSelect__sQZsh","primaryTag":"CompanyUserList_primaryTag__oADZ0","badgeUserGuest":"CompanyUserList_badgeUserGuest__LZ2aZ"};